export default function isString(value: unknown): value is string {
    return value !== undefined && value !== null && (typeof value === 'string' || value instanceof String)
}
